var TableHelper = {};
TableHelper.SetSelectAllStateForTable = function ($table) {
  if ($table.length == 0) return;

  var $selectAll = $table.find('thead > tr > th .select-all');

  if ($selectAll.length == 0) return;

  var isAllChecked = $table.find('tbody > tr:visible > .row-selector > input[type="checkbox"]:not(:checked)').length == 0;
  $selectAll.attr('checked', isAllChecked);

  TableHelper.SyncSelectAllForFixedHeader($table, isAllChecked);
};

TableHelper.SingleSelectRow = function ($table, $siblingRows, $targetRow) {
  var $newSelectedRow = null;
  var shouldSelect = $targetRow.hasClass('selected') == false;

  if (shouldSelect) {
    $siblingRows.removeClass('selected');
    $targetRow.addClass('selected');
    $newSelectedRow = $targetRow;
  }
  else {
    $targetRow.removeClass('selected');
  }

  var $input = $targetRow.find('.row-selector input[type="radio"]');
  if ($input.length == 1) {
    $input.attr('checked', shouldSelect);
    $input.change();
  }

  var event = jQuery.Event('rowselectionchanged');
  event.selectedRow = $newSelectedRow;
  $table.trigger(event);
};

TableHelper.HandleSingleRowVisible = function ($table) {
  var isSingleRowVisible = $table.find('tr:visible').length == 1;
  $table.toggleClass('table-single-row-visible', isSingleRowVisible);
};

(function ($) {
  $(document)
    .on('mousedown.rustig.table', '.table:not(.table-display):not(.multiselect) > tbody > tr:not(.tr-group)', function(e) {
      if ($(e.target).is('a')) return;

      TableHelper.SingleSelectRow($(this).closest('.table'), $(this).siblings('tr'), $(this));
    })
    .on('change.rustig.table', '.fht-thead .fht-table > thead > tr > th .select-all', function(e) {
      var $realTable = $(this).closest('.fht-table-wrapper').find('.fht-tbody .table:not(.table-display).multiselect');
      $realTable.find('thead > tr > th .select-all').click();
    })
    .on('visibilitychanged.rustig', 'tbody tr', function(e){
      $(this).each(function () {
        var $table = $(this).closest('.table');
        TableHelper.HandleSingleRowVisible($table);
      });
    });

  $('.table').each(function () {
    TableHelper.HandleSingleRowVisible($(this));
  })
})(jQuery);